import { render } from "./ImportExaminableTasks.vue?vue&type=template&id=10deefbd&scoped=true"
import script from "./ImportExaminableTasks.vue?vue&type=script&lang=js"
export * from "./ImportExaminableTasks.vue?vue&type=script&lang=js"

import "./ImportExaminableTasks.vue?vue&type=style&index=0&id=10deefbd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10deefbd"]])

export default __exports__